// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3NJP6","list":"styles_list__1kMxw"};